export default function ivrReducer(ivr, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...ivr, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "repeat":
    case "inputTimeout":
      return { ...ivr, [action.type]: Number(action.value) };
    case "announcement":
    case "timeoutAnnouncement":
    case "invalidAnnouncement":
      if (action.value === null) {
        return { ...ivr, [action.type]: { id: null } };
      } else {
        return { ...ivr, [action.type]: action.soundStore.list.find((sound) => sound.id === action.value) };
      }

    case "addOption":
      return { ...ivr, options: [...ivr.options, action.option] };
    case "updateOption":
      return {
        ...ivr,
        options: ivr.options.map((_option) => {
          if (_option.input === action.option.input) {
            _option = action.option;
          }
          return _option;
        }),
      };
    case "deleteOption":
      return { ...ivr, options: ivr.options.filter((option) => option.id !== action.option.id) };

    default:
      return { ...ivr, [action.type]: action.value };
  }
}
